export const config = {
  rowSelection: false,
  pagination: false,
  columns: [
    {
      title: '产品SPU',
      dataIndex: 'cateName',
      width: 350,
      render: 'renderProduct',
    },
    {
      title: '单位',
      dataIndex: ['unitInfo', 'unitName'],
      width: 160,
      ellipsis: true,
    },
    {
      title: '数量',
      dataIndex: 'size',
      width: 160,
      ellipsis: true,
    },
    {
      title: '是否可查看',
      dataIndex: 'allowView',
      width: 120,
      render: v => v ? '是': '否',
    },
    {
      title: '是否必选',
      dataIndex: 'required',
      width: 120,
      render: v => v ? '是': '否',
    },
    {
      title: '是否参与计算',
      dataIndex: 'allowCalculation',
      width: 120,
      render: v => v ? '是': '否',
    },
    {
      title: '是否发包',
      dataIndex: 'allowSendPack',
      width: 120,
      render: v => v ? '是': '否',
    },
    {
      title: '开始日期',
      dataIndex: 'startDate',
      width: 160,
      itemType: 'date',
    },
    {
      title: '结束日期',
      dataIndex: 'endDate',
      width: 160,
      itemType: 'date',
    },
    {
      title: 'SPU适用门店',
      dataIndex: 'applyProductShopList',
      width: 200,
      ellipsis: true,
      render: 'shopNameRender',
    },
    {
      title: 'SPU状态',
      dataIndex: 'spuEnabled',
      width: 120,
      render: 'enabledRender',
      fixed: 'right',
    },
    {
      title: 'SKU包含类型',
      dataIndex: 'selectTypeName',
      width: 140,
      fixed: 'right',
    },
    {
      title: '操作',
      dataIndex: 'id',
      fixed: 'right',
      render: 'actionRender',
      width: 100,
    },
  ],
  search: [
    {
      name: 'productKeyword',
      label: 'SPU名称/ID',
    },
    {
      name: 'currentDate',
      itemType: 'date',
      label: '日期',
    },
  ],
  footer: [
    {
      label: '去编辑',
      type: 'primary',
      events: ['onClick:toEdit'],
      auth: 'toEditCombinationBtn',
    },
  ]
}